import apiUrl from "../../../constants";
import axios from "axios";
import iptrackerdetails from "../../../iptrackerdetails";

import Paginate from "vuejs-paginate";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: "verticalType",
    components: {
        Paginate,
        VueElementLoading,
    },
    data: function () {
        return {
            modalShow: false,
            addverticalTypemodal: false,
            verticalTypeaction: "",
            listVerticalTypeData: [],
            props: [],
            pageno: 0,
            pagecount: 0,
            verticalTypename: "",
            searchverticalTypename: "",
            verticalTypeid: "",
            isLoading: false,
            resultCount: "",
            is_active: "",
            changestatus: "",
            count: 0,
            businessverticalid: "",
            businesssubverticalid: 0,
            businessverticallist: [],
            buinesssubverticallist: [],
            verticalfunctionId: 0,
            verticalfunctionlist: [],
        };
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem("userdetail");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail;
        this.localuserid = userdetail.userid;
        this.localusername = userdetail.username;
        this.getVerticalTypeData();
        this.getBusinessVertical();
    },
    methods: {
        addNewVerticalType() {
            (this.is_active = "true"), (this.verticalTypeid = "");
            (this.verticalTypename = ""),
                (this.verticalTypeaction = "add"),
                (this.addverticalTypemodal = true),
                this.$validator.reset();
            this.errors.clear();
        },
        closeAddVerticalTypeModal() {
            $("#verticalTypeform").trigger("reset");
            (this.addverticalTypemodal = false), this.$validator.reset();
            this.errors.clear();
        },
        closeStatusVerticalTypeModal() {
            this.modalShow = false;
        },
        searchVerticalTypeData() {
            this.pageno = 0;
            this.$refs.paginate.selected = 0;
            this.getVerticalTypeData();
        },
        getVerticalTypeData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            this.input = {
                offset: this.pageno,
                limit: 10,
                verticaltype: this.searchverticalTypename,
                pagination: true,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "GetverticaltypeUM",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listVerticalTypeData = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count;
                    this.resultCount = result.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getBusinessVertical() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            this.input = {};
            axios({
                method: "POST",
                url: apiUrl.api_url + "GetBverticalslist",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.businessverticallist = result.data.data.rows;
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getBusinessSubVertical() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            this.input = {
                buiness_vertical_id: this.businessverticalid,
            };
            axios({
                method: "POST",
                url: apiUrl.api_url + "GetBSVerticalsList",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.buinesssubverticallist = result.data.data.rows;
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getVerticalFunction() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            this.input = {
                buinesssubverticalsid: this.businesssubverticalid,
                pagination: false,
            };
            axios({
                method: "POST",
                url: apiUrl.api_url + "GetverticalfunctionsListUM",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.verticalfunctionlist = result.data.data.rows;
                },
                (error) => {
                    console.error(error);
                }
            );
        },

        saveVerticalType(event) {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            this.input = {
                verticaltype: this.verticalTypename,
                verticalfunctionsid: this.verticalfunctionId,
            };
            axios({
                method: "POST",
                url: apiUrl.api_url + "Createverticaltype",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            })
                .then((response) => {
                    if (response.data.code == 200) {
                        this.$alertify.success(response.data.msg);
                        this.addverticalTypemodal = false;
                        event.target.reset();
                        this.resetForm();
                    } else {
                        this.$alertify.error(response.data.msg);
                    }

                    iptrackerdetails.checkUserIP(
                        this.iptrackData,
                        "Save User Type",
                        this.$route.path,
                        this.input,
                        response.data
                    );
                })
                .catch((httpException) => {
                    console.error("exception is:::::::::", httpException);
                });
        },

        getVerticalTypeRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.verticalTypeaction = "edit";
            this.addverticalTypemodal = true;
            this.verticalTypename = data.verticalTypename;
            this.verticalTypeid = data.verticalTypeid;
            this.is_active = data.is_active;
        },

        editVerticalType(event) {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            this.input = {
                verticalTypeid: this.verticalTypeid,
                verticalTypename: this.verticalTypename,
                modifiedby: this.localuserid,
                is_active: this.is_active,
            };
            axios({
                method: "POST",
                url: apiUrl.api_url + "updateVerticalType",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.addverticalTypemodal = false;
                        event.target.reset();
                        this.resetForm();
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg);
                    }
                    iptrackerdetails.checkUserIP(
                        this.iptrackData,
                        "Update User Type",
                        this.$route.path,
                        this.input,
                        response.data
                    );
                })
                .catch((httpException) => {
                    console.error("exception is:::::::::", httpException);
                });
        },

        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10;
            this.getVerticalTypeData();
        },

        //to get target id in active/inactive modal
        getStatusRowData(data) {
            this.Statusaction = "add";
            this.modalShow = true;
            this.verticalTypeid = data.verticalTypeid;
            this.is_active = data.is_active;
            if (data.is_active === true) {
                this.changestatus = "De-Activate";
            } else {
                this.changestatus = "Activate";
            }
        },

        //for active/inactive modal
        changeVerticalTypeStatus() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            let reqpayload = {
                verticalTypeid: this.verticalTypeid,
                is_active: this.is_active,
            };

            axios({
                method: "POST",
                url: apiUrl.api_url + "updateVerticalTypeStatus",
                data: reqpayload,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.addverticalTypemodal = false;
                        this.getVerticalTypeData();
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg);
                    }
                    iptrackerdetails.checkUserIP(
                        this.iptrackData,
                        "Update User Type Status",
                        this.$route.path,
                        reqpayload,
                        response.data
                    );
                })
                .catch((httpException) => {
                    console.error("exception is:::::::::", httpException);
                });
        },

        onSubmit: function (event) {
            this.$validator
                .validateAll()
                .then((result) => {
                    if (result) {
                        if (this.verticalTypeid != undefined && this.verticalTypeid != "") {
                            this.editVerticalType(event);
                        } else {
                            this.saveVerticalType(event);
                        }
                    }
                })
                .catch(() => {
                    console.log("errors exist", this.errors);
                });
        },
        resetSearch() {
            this.searchverticalTypename = "";
            this.pageno = 0;
            this.$refs.paginate.selected = 0;
            this.getVerticalTypeData();
        },
        resetForm() {
            this.verticalTypeid = "";
            this.verticalTypename = "";
            this.verticalTypeaction = "add";
            this.is_active = "";
            this.$validator.reset();
            this.errors.clear();
            this.getVerticalTypeData();
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/components/verticaltype/verticalType.component.js